import React from 'react';

import { ErrorComponent, TextError } from './styles';

interface IError {
  id?:string;
  enable: boolean;
  message?: string;
  justifyContent?: 'flex-start' | 'center' | 'flex-end';
  className?:string;
}

const Error: React.FC<IError> = ({id, enable, message, justifyContent, className }) => {
  return (
    <ErrorComponent id={id} justifyContent={justifyContent} className={`textError ${className}`}>
      {enable && <TextError>{message}</TextError>}
    </ErrorComponent>
  );
};

export default Error;
